import React from "react";
import MatDialog from "material-ui/Dialog";

const styles = {
  contentStyle: {
    width: "100%",
    maxWidth: null
  },
  bodyStyle: {
    padding: null
  }
};

class Dialog extends React.Component {
  render() {
    let classes = "popup";
    if (this.props.className) {
      classes = classes + " " + this.props.className;
    }

    return (
      <MatDialog
        className={classes}
        autoScrollBodyContent={ true }
        paperClassName="popup-bg"
        bodyClassName={"popup-inner " + (this.props.bodyClassName || '')}
        contentClassName="popup-content"
        contentStyle={styles.contentStyle}
        bodyStyle={styles.bodyStyle}
        title={this.props.title}
        open={this.props.open}
        onRequestClose={this.props.handleClose}
      >
        {this.props.children}
      </MatDialog>
    );
  }
}

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/UI/Dialog.js